import { render, staticRenderFns } from "./noticeManager.vue?vue&type=template&id=d324db56&"
import script from "./noticeManager.vue?vue&type=script&lang=js&"
export * from "./noticeManager.vue?vue&type=script&lang=js&"
import style0 from "./noticeManager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports